import { Navigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { getSavedToken, isTokenExpired } from "../utils/tokenHelper";
import { setQrCode } from "../redux/slices/qrSlice";

export default function PublicRoute({ children }) {
  const dispatch = useDispatch();
  const { code } = useParams();

  const tokenData = getSavedToken();
  const isLoggedIn =
    localStorage.getItem("isLoggedIn") === "true" &&
    tokenData &&
    tokenData.access_token &&
    !isTokenExpired(tokenData);

  useEffect(() => {
    if (isLoggedIn && code) {
      dispatch(setQrCode(code));
      localStorage.setItem("qrCode", code);
    }
  }, [isLoggedIn, code, dispatch]);

  if (isLoggedIn) {
    const isNewUser = localStorage.getItem("isNewUser") === "true";
    return <Navigate to={isNewUser ? "/profile-setup" : "/home"} replace />;
  }

  return children;
}